<template>
  <div style="background-color: #fff">
    <div class="flex-center">
      <div class="nectar-video-inner">
        <div
          class="row-bg-overlay row-bg-layer"
          style="background-color: #000000; opacity: 0.3"
        ></div>
        <div
          class="nectar-video-bg"
          width="100%"
          height="auto"
          preload="auto"
          loop=""
          autoplay=""
          muted=""
          playsinline=""
          style="
            visibility: visible;
            width: 100%;
            height: 100%;
            object-fit: cover;
          "
        >
          <img
            style="width: 100%; height: 125%"
            src="../assets/2024/04/Data-Science-is-Different-From-Data-Analytics.jpg"
            alt=""
          />
        </div>
        <div class="video-content">
          <div class="video-content-left">
            <div class="wenzhang"  @click.stop="gotoarticle('companypages')">Company News & Blogs</div>
            <p class="video-content-title">
              The Association of International Credit and Trade Finance
              Professionals
            </p>
            <p style="text-align: center; margin-top: 20px">
              <span class="Financial-text">April 18, 2024</span
              ><span class="Financial-text">No Comments</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="fincal-content">
      <p class="fincal-head" style="margin-left: -13%">
        <a class="fincalrouter" href="">Home</a> » The Association of
        International Credit and Trade Finance Professionals
      </p>
      <div class="fincal-wenzi fincal-head">
        Paul Boynton, COO and Co-Founder of CSI led a discussion on transforming
        data into business intelligence, the Data, Information, Knowledge,
        Wisdom (DIKW) hierarchy of knowledge at the International Credit and
        Trade Finance (ICTF) Global Credit Professionals Symposium in Las Vegas,
        held April 7-9. Paul commented on the significance of the DIKW hierarchy
        and why it’s important for understanding the Business Information
        industry.
      </div>
      <div class="fincal-wenzi fincal-head">
        ICTF is an educational organization centered on credit management and
        trade finance. Their members are professionals that make real-world
        decisions for trade and commerce, navigating their businesses through a
        very uncertain world. Access to reliable information is mission-
        critical. It’s important to understand how raw data is transformed into
        credible, reliable information in the DIKW hierarchy framework. DIKW is
        a sophisticated process that information users should have a basic
        understating of.
      </div>
            <div class="fincal-wenzi fincal-head">
    Credit managers can be inundated with data on customers- financial, legal, trade, media, to incident logs. However, simply having the data isn’t enough but by applying context and analysis, data is transformed into information where patterns and trends reveal insights and potential risks. But the intelligence chain doesn’t stop there, progressing up the DIKW pyramid, knowledge is formed by combining information with experience and expertise. A credit manager with knowledge can not only identify risks but also assess and benchmark the likelihood and impact of risks.
      </div>
            <div class="fincal-wenzi fincal-head">
  Ultimately at the top of the pyramid lies wisdom – the ability to make judgments, rationalize, organize, and strategize business going forward. In other words, the insight needed to plan and run an organization.
      </div>
            <div class="fincal-wenzi fincal-head">
CSI BIZ INFO is a thought leader in the Business Intelligence industry and the DIKW hierarchy is a core part of our process to provide continuous, fresh, relevant information and product development. Our big data sets us apart from our peers to provide intelligence and analytics on customers, vendors, supply chain, ownership, products, markets, and media. We work hard to provide the intelligence needed to understand not only your customer, but how that company fits in their business community- the true “DNA” of your customer. Understanding your customers DNA with a platform like CSI is what modern day credit managers need to fully understand the environment their customers operate.
      </div>
                <div class="fincal-wenzi fincal-head">
                    <h4>This Is Core To The Products And Services We Bring To Our Subscribers</h4>
      </div>
    </div>
    <div class="flex-center nextewnzheng">
      <div class="nectar-video-inner nectar-video-innertwo">
        <div
          class="row-bg-overlay row-bg-layertwo"
          style="background-color: #000000; opacity: 0.3"
        ></div>
        <!-- <div
          class="nectar-video-bgtwo"
          width="100%"
          height="auto"
          preload="auto"
          loop=""
          autoplay=""
          muted=""
          playsinline=""
          style="
            visibility: visible;
            width: 100%;
            height: 100%;
            object-fit: cover;
          "
        >
          <img
          class="imgscale"
            style="width: 100%; height: 100%"
            src="../assets/2024/05/Downloader.la-664234ed94f66.jpg"
            alt=""
          />
        </div> -->
        <div class="video-content">
          <div class="video-content-left" style="top: 33%">
            <div class="wenzhangtwo" @click="gotoarticle('loan')">
              Next Post
            </div>
            <p style="font-size: 47px; color: #fff;">
              How To Get A Fast Business Loan 2024
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Products",
  data() {
    return {};
  },
  watch: {
    //   '$route.hash': function() {
    //     // 在这里可以处理hash变化后的逻辑
    //   this.scrollToAnchor()
    //   }
  },
  methods: {
    //  scrollToAnc
    gotoarticle(route) {
      console.log(route);
      this.$router.push({ name: route });
      // window.location.hash = "#about#top";
    },
    //   const el = document.querySelector(this.$route.hash);
    //   el.scrollIntoView({ behavior: "smooth" });
    // },
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.scrollToAnchor()
  },
};
</script>

<style scoped>
ol,
ul {
  margin-left: 30px;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.nectar-video-inner {
  width: 100%;
  position: relative;
  height: 610px;
}
.row-bg-layer {
  position: absolute;
  width: 100%;
  height: 610px;
  z-index: 9;
}
.row-bg-layertwo {
  position: absolute;
  width: 100%;
  height: 390px;
  z-index: 9;
}
.video-content {
  /* z-index: 10; */
  width: 100%;
  display: flex;
  justify-content: center;
  /* position: relative; */
}
.postion {
  position: absolute;
  top: 26%;
  right: 19%;
  width: 25%;
  z-index: 11;
}
.video-content-title {
  font-size: 81px;
  color: #fff;
  margin-bottom: 0px;
  width: 83%;
  margin: auto;
  text-align: center;
}
.video-content-left {
  position: absolute;
  z-index: 11;
  top: 28%;
  text-align: center;
}
.start_font {
  font-family: "AlegreyaSans-Medium";
  font-size: 61px;
  width: auto;
  color: #1290c9;
  text-align: left;
  font-style: normal;
  position: relative;
  display: inline-block;
  z-index: 10;
}
.focus {
  position: relative;
}
h2 {
 font-family: "Alegreya Sans" !important;
  font-size: 46px;
  line-height: 56px;
  font-weight: 500;
  margin: 7px 0px;
}

head {
}
h3 {
font-family: "Alegreya Sans" !important;
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
  /* color: #3d7cbf; */
  text-align: left;
  margin-bottom: 8px;
  margin-top: 10px;
}
.nectar-video-bg {
  height: 100%;
  position: relative;
  top: -25%;
}
.Financial-text {
  padding: 0 20px;
  border-left: 1px solid #ccc;
  color: #fff;
}
.fincalrouter {
  color: #1290c9;
}
.fincal-content {
  margin: auto;
  width: 69%;
  padding: 80px 0px;
  font-size: 18px;
}
.fincal-head {
  padding-bottom: 27px;
}
.fincal-wenzi {
  font-family: Roboto;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
}
.wenzhang {
  color: #fff;
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  width: 200px;
  margin: auto;
  margin-top: -50px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.wenzhangtwo {
  color: #fff;
  padding: 6px;
  font-size: 18px;
  margin: auto;
}
.nectar-video-innertwo {
  height: 390px;
  background-image: url("../assets/2024/03/Downloader.la-6601ec0085b75.jpg");
  background-position-y: -300px;
  transition: transform 0.42s ease;
  background-size: 100%;
}
.nextewnzheng {
  overflow: hidden;
}
.nextewnzheng {
  transition: transform 0.42s ease;
}

.nextewnzheng:hover .nectar-video-innertwo {
  cursor: pointer;
  transform: scale(1.1);
  transition: transform 0.42s ease;
}
.nextewnzheng :hover .row-bg-layertwo {
  opacity: 0.1 !important;
}
@media screen and (max-device-width: 415px) {
  .video-content-title {
    font-size: 51px;
  }
}
</style>